import { useMemo } from "react";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves box number data.
 * @returns - A promise that resolves to the codes data.
 */
export const useFetchCodes = () => {
  const memoizedFetchCodes = useMemo(
    () => async () => {
      return apiGet("/codes", "fetching Codes");
    },
    []
  );

  return memoizedFetchCodes;
};
